import script from "./d-d.vue?vue&type=script&setup=true&lang=js"
export * from "./d-d.vue?vue&type=script&setup=true&lang=js"

import "./d-d.vue?vue&type=style&index=0&id=39ff8f94&scoped=true&lang=css"

import exportComponent from "/home/gary/Git-Projects/rcmg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ff8f94"]])

export default __exports__